import {AuthServiceInterface} from './interface';
import AuthService from "@services/AuthService/AuthService";

/**
 *  Фабрика сервиса генерации даты продукта с замороженными сущностями
 */
export const authService: { (): AuthServiceInterface } = () => new AuthService();
